import React, { useState } from 'react';
import classNames from 'classnames';

import ContentFeed from '../ContentFeed';
import ProductFilterBar from '../ProductFilterBar';
import Button from '../Button';

import ProductCard from '../ProductCard';

const ns = `product-listing`;

const PromoView = ({ promo }) => {
	return (
		<div className={`${ ns }__promo-container`}>
			<div className={`${ ns }__promo`}>
				<div className={`${ ns }__promo-content`}>
					{promo.subtitle && (
						<div className={`${ ns }__promo-subtitle eyebrow`}>{promo.subtitle}</div>
					)}
					{promo.title && <div className={`${ ns }__promo-title`}>{promo.title}</div>}
				</div>
				{promo.link?.label && promo.link?.url && (
					<div className={`${ ns }__promo-link`}>
						<Button to={promo.link.url}>
							{promo.link.label}
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};

const ProductListing = ({
	location,
	category,
	nextVisibleAmount,
	products = [],
	promo,
	activeCampaign,
	campaignCopy,
	title,
	onLoadMore,
	initialVisibleAmount,
	description,
	isH1 = false,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	// array of items to render
	const [filteredProducts, setFilteredProducts] = useState([...products]);
	const [filterTransition, setFilterTransition] = useState(false);

	const productView = (p, index) => {
		let hasActiveCampaign = null;
		p.metafields?.forEach(metafield => {
			if (metafield.key === 'has_active_campaign') {
				hasActiveCampaign = metafield.value;
			}
		});

		if (p.promo) {
			return <PromoView key={promo.title} promo={promo} />;
		}
		return (
			<ProductCard
				location={location}
				category={category}
				product={p}
				key={p.id}
				index={index}
				hasActiveCampaign={hasActiveCampaign}
				activeCampaign={activeCampaign}
				campaignCopy={campaignCopy}
				hideQuickshop
				hideTag
				hideRating
			/>
		);
	};

	const handleFilteredProducts = items => {
		setFilterTransition(true);
		setTimeout(() => {
			setFilteredProducts(items);
			setFilterTransition(false);
		}, 750);
	};

	const filterTransitionClass = filterTransition ? 'filter-transition' : '';

	return (
		<div className={rootClassnames}>
			<div className={'container'}>
				<ProductFilterBar
					page={'category'}
					products={[...products]}
					handleFilteredProducts={handleFilteredProducts}
				/>
				{title && description && (
					<div className={`${ ns }__heading`}>
						{isH1 ? (
							<h1 className={`${ ns }__heading-title`}>
								{title}
							</h1>
						) : (
							<div className={`${ ns }__heading-title`}>
								{title}
							</div>
						)}
						<div className={`${ ns }__heading-description`}>
							{description}
						</div>
					</div>
				)}
				<div className={`${ ns }__items ${ filterTransitionClass }`}>
					<ContentFeed
						location={location}
						page={'category'}
						items={filteredProducts}
						itemView={productView}
						initialVisibleAmount={initialVisibleAmount}
						nextVisibleAmount={nextVisibleAmount}
						promo={promo?.active}
						noContainer
						onLoadMore={onLoadMore}
					/>
				</div>
			</div>
		</div>
	);
};

export default ProductListing;
